<template>
  <div
    class="mobileLanding"
    v-touch:swipe.left="(e) => swipeLanding(e)"
    v-touch:swipe.right="(e) => swipeLanding(e)"
  >
    <LandingBackgroundMobile></LandingBackgroundMobile>

    <div class="mobileLanding__header">
      <Header></Header>
    </div>

    <transition-group :name="direction">
      <div
        class="mobileLanding__side"
        v-if="(landingIndex === -1 && !isModalOpen) || $tvaMq !== 'mobile'"
        key="social-buttons"
      >
        <SocialShare />
      </div>
    </transition-group>

    <div class="mobileLanding__center">
      <transition :name="`${direction}${transitionPostfix}`">
        <SourceCoverMobile v-if="landingIndex >= 0 && !menuOrModalActive" />
        <MainCoverMobile v-if="landingIndex === -1 && !menuOrModalActive" />
        <MenuMobile v-if="isMenuOpen" />
      </transition>
    </div>

      <BtnDownloadMobile />

    <transition :name="direction">
      <Modal v-if="isModalOpen"></Modal>
    </transition>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import SocialShare from "@/components/SocialShare.vue";
import Modal from "@/components/modal/Modal.vue";
import MainCoverMobile from "../components/mobile/MainCoverMobile.vue";
import MenuMobile from "../components/mobile/landingComponents/MenuMobile.vue";
import SourceCoverMobile from "../components/mobile/SourceCoverMobile.vue";
import landingMobileHandler from "../mixins/landingMobileHandler";
import LandingBackgroundMobile from "../components/mobile/landingComponents/LandingBackgroundMobile.vue";
import BtnDownloadMobile from "@/components/mobile/landingComponents/BtnDownloadMobile.vue";
import { mapActions } from "vuex";

export default {
  mixins: [landingMobileHandler],
  components: {
    Header,
    MainCoverMobile,
    SocialShare,
    Modal,
    LandingBackgroundMobile,
    MenuMobile,
    SourceCoverMobile,
    BtnDownloadMobile,
  },
  data() {
    return {
      menuWasOpen: false,
    };
  },
  computed: {
    menuOrModalActive() {
      return this.isMenuOpen || this.isModalOpen;
    },
    transitionPostfix() {
      const conditionalIndex = this.direction === "rtl" ? 1 : 0;
      return this.landingIndex >= conditionalIndex &&
        !this.menuOrModalActive &&
        !this.menuWasOpen
        ? "elements"
        : "";
    },
  },
  watch: {
    landingIndex() {
      if (this.menuWasOpen) {
        // After animation has initiated with correct value, reset menuWasOpen
        this.$nextTick(() => (this.menuWasOpen = false));
      }
    },
    isMenuOpen(newValue) {
      // If modal was open but has been closed, indicate that the modal
      // was open, to make sure we still have the correct out-transition for the modal
      if (!newValue) {
        this.menuWasOpen = true;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setLink(from);
      // vm.link = from;
      vm.show = true;
    });
    next();
  },
  methods: {
    ...mapActions({
      setLink: "ui/setPreviousLink",
    }),
  },
};
</script>

<style lang="scss" scoped>
.mobileLanding {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  &__header {
    pointer-events: none;
    height: fit-content;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 4;
  }

  &__side {
    position: absolute;
    top: 0;
    left: 0;
    width: 16.8vw;
    border: none;
    margin-top: 8.2vh;
    z-index: 3; // to be over multiplied background
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__center {
    flex-grow: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 2;
    height: fit-content;
    position: relative;
  }
}

.tablet {
  .mobileLanding {
    &__side {
      width: $header-width-tablet;
    }
  }
}
</style>
